var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector53(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 308,
    viewBox: "0 0 98 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.635 307.495C305.247 288.58 301.54 284.461 286.724 265.053C283.094 260.298 277.382 251.054 271.927 239.636C270.292 236.22 268.81 232.831 267.451 229.491C257.757 205.583 256.389 178.8 258.641 152.349C264.391 84.8603 227.859 23.9483 172.548 6.19103C117.132 -11.6137 55.6154 17.6559 25.5935 63.3162C21.6875 69.2574 4.4575 97.2932 1.91053 128.053C-6.15803 225.172 87.9182 263.98 231.062 293.364C233.846 293.933 247.104 296.107 249.917 296.496L328.645 307.495H328.635Z",
    stroke: "#1E1E22",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector53);
export default __webpack_public_path__ + "static/media/vector5-3.8fb346b0cf636b684d08fb30ad84ed23.svg";
export { ForwardRef as ReactComponent };